import { combineReducers } from 'redux'
import { authReducer } from './auth'
import { contractorPortalAuthReducer } from './contractorPortalAuth'
import { contractorPortalPartnersReducer } from './contractorPortalPartners'
import { contractorPortalInvoicesReducer } from './contractorPortalInvoices'
import { contractorPortalDocumentsReducer } from './contractorPortalDocuments'
import { documentsReducer } from './documents'
import { partnerReducer } from './partner'
import { driverReducer } from './driver'

export const rootReducer = combineReducers({
  auth: authReducer,
  contractorPortalAuth: contractorPortalAuthReducer,
  contractorPortalPartners: contractorPortalPartnersReducer,
  contractorPortalInvoices: contractorPortalInvoicesReducer,
  contractorPortalDocuments: contractorPortalDocumentsReducer,
  documents: documentsReducer,
  driver: driverReducer,
  partner: partnerReducer,
})
